import React, { useEffect, useState, ReactNode } from 'react';
import { NavLink, useLocation, useRoutes, useNavigate } from 'react-router-dom';
import Login from '../page/login/login';
import Home from '../page/home/home';
import { NotFInd } from '../page/notfound/notfind';
import { Modify } from '../page/modify/modify';
import {ChildDevice} from "../page/home/child/device";

type Props = {};

interface WaylayProps {
  children: ReactNode; // ReactNode 表示任何 React 元素
}
export const GetRoutes = (props: Props) => {
  interface WaylayProps {
    children: ReactNode;
  }

  const Waylay: React.FC<WaylayProps> = ({ children }) => {
    // let token = localStorage.getItem('Authorization');
    // let navigate = useNavigate();
    // if (!token) {
    //   navigate('/');
    //   return null;
    // }

    return <div>{children}</div>;
  };

  return (
    <div>
      {useRoutes([
        {
          path: '/',
          element: <Login />,
        },
        {
          path: '/home',
          element: (
            <Waylay>
              <Home />
            </Waylay>
          ),
        },
        {
          path: '/modify',
          element: <Modify />,
        },
        {
          path: '*',
          element: <NotFInd />,
        },
      ])}
    </div>
  );
};
